import { forwardRef, ReactNode, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { BT, Container, ImageContainer, ItemInfo, ItemName, ListContainer, TagPill, TopTitle } from './GuardianSick.styled';
import { Buttons, ChildContainer, ChildInfo, HeadLine, ItemButtons, LessonItem, LessonList, PillContainer, PopCal, PopClose, PopCol, PopContainer, PopItem, PopRow, PopRowButtons, PopSubTitle, PopTitle } from '../Guardian.styled';
import DatePicker, { registerLocale } from 'react-datepicker';
import { da } from 'date-fns/locale/da';
import { enGB as en } from 'date-fns/locale/en-GB';
import { useDetectClickOutside } from 'react-detect-click-outside';
import Clock_Icon from "@assets/svg/match/late.svg";
import Attendance_Icon from "@assets/svg/match/attending.svg";
import Calendar_Icon from "@assets/svg/new_calendar.svg";
import StudentThumbnail from '@components/StudentThumbnail';
import Modal from '@components/Buttons/Modal';
import Close_Icon from "@assets/svg/match/missing.svg";
import Plus_Icon from "@assets/svg/chevron-down.svg";
import moment from 'moment';
import EmptyBox from '@components/SchoolLeader/EmptyBox';
import RainbowLoader from '@components/Loaders/RainbowLoader';
import CardInfo from '@components/GridCards/CardInfo';
import toTitleCase from '@utils/textTools';
import db from '@utils/db';
import { useStore } from "@store/appStore";
import DateSelect from '../DateSelect';

registerLocale('da', da);
registerLocale('en-GB', en);


interface IProps {
  updateStudents?: () => void,
  sickList?: any,
  students?: any,
  loading?: boolean,
  studentId?: string,
  username?: string,
  displayname?: string;
  handleEditSick?: (requestinfo) => void
}

export const GuardianSick = forwardRef((props: IProps, ref) => {
  const i18n = useI18n();
  const [showAll, setShowAll] = useState(false)
  const [ShowOpen, SetShowOpen] = useState(-1)
  const { client, systemSettings } = useStore()
  const [alltags, setAlltags] = useState([])
  const [deleteModal, setDeleteModal] = useState(null)
  const deleteRef = useRef(null);
  const [sickList, setSickList] = useState([])
  const [loading, setLoading] = useState(true)
  const editRef = useRef(null);
  const [editModal, setEditModal] = useState(null)

  useImperativeHandle(ref, () => ({
    update() {
      getSickTimeblocks()
    },
  }));

  useEffect(() => {
    getAllTags()
  }, []);

  useEffect(() => {
    if(alltags.length > 0){
      getSickTimeblocks()
    }
  }, [ShowOpen, showAll, props.studentId, alltags, i18n.language]);

  const getAllTags = async () => {
    let allTags = await db.getAllNote_Tags();
    setAlltags(allTags)
  }

  const showDeleteModal = (sickevent) => {
    setDeleteModal(sickevent[0].absence_id)
  }

  const showEditModal = (sickevent) => {
    let dates = sickevent.map(t => t.date)
    let fromDate;
    let toDate;
    if (sickevent.length > 0) {
      fromDate = dates?.reduce(function (a, b) { return a < b ? a : b; });
      toDate = dates?.reduce(function (a, b) { return a > b ? a : b; });
    }
    props.handleEditSick({
      absence_id: sickevent[0].absence_id,
      fromDate: fromDate,
      toDate: toDate,
      text: sickevent[0].text
    })
  }

  const deleteSickRequest = async () => {
    await db.deleteSickEvent4Student(deleteModal)
    getSickTimeblocks()
    props.updateStudents()
    deleteRef?.current?.handleClose()
    setDeleteModal(null)
  }

  const closeDeleteModal = () => {
    deleteRef?.current?.handleClose()
    setDeleteModal(null)
  }

  function GetDates(arr) {
    const sorted = [...arr].sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());

    return (moment(sorted[0].date).format("DD-MM-YYYY") + " - " + moment(sorted[sorted.length - 1].date).format("DD-MM-YYYY") )
  }

  const getSickTimeblocks = async () => {
    let i = (await db.getSickEvent4Student(props.studentId, 30)) ?? [];
    let grouped = i.reduce((acc, obj) => {
      const key = obj.absence_id;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});


    grouped = Object.values(grouped)

    let filterGrouped = []
    if (showAll) filterGrouped = grouped?.sort((a, b) => moment(b[0].date).diff(moment(a[0].date)));
    else {
      let now = moment()
      filterGrouped = grouped?.sort((a, b) => moment(b[0].date).diff(moment(a[0].date)))?.filter(a => moment(new Date(Math.max(...a.map(x => new Date(x.date).getTime())))).isSameOrAfter(now, 'date'))
    }

    if (filterGrouped.length > 0) {
      let ts = filterGrouped?.map((m, index) => {
        return <PopItem style={{marginBottom:"0px"}} key={"fs_" + index}>
          <PopRow>
            <ChildContainer>
                <ImageContainer>
                  <StudentThumbnail name={props.displayname} src={props.username} />
                </ImageContainer>
                <ItemInfo>
                  <ItemName>{props.displayname}</ItemName>
                  {/* <TagPill PColor={"rgb(41, 128, 185)"}>{i18n.t("guardian-holiday-text")}</TagPill> */}
                  <div><Calendar_Icon /> {GetDates(m)}</div>
                  
                </ItemInfo>
            </ChildContainer>
          </PopRow>
          <PopRow style={{padding:"0"}}>
            <PillContainer>
              {getTags(m[0]?.tag_ids, m[0]?.absence_id, m[0]?.absencetype)}
            </PillContainer>
          </PopRow>
          <PopRow>
            <PopSubTitle icon={true} expand={ShowOpen === m[0].absence_id}>{i18n.t("guardian-lesson")} ({m.length})<Calendar_Icon />{m.length > 2 ? <div onClick={() => SetShowOpen(prev => prev === m[0].absence_id ? -1 : m[0].absence_id)}><Plus_Icon /></div> : null}</PopSubTitle>
            <LessonList>
              {m.slice(0, ShowOpen === m[0].absence_id ? m.length : 2)
                .map((t, index) => (
                  <LessonItem key={"timeblock_" + index}>
                    <div>
                      {GetTypeIcon(t.absence_type)}
                      <div>
                        <div>
                          <b>{moment(t.date).format("DD-MM-YYYY") + "   " + getDateTime(t.starttime, t.endtime)}</b>

                        </div>
                        <div>
                          <b>{t.displayname}</b> {t.coursedescription}
                        </div>
                      </div>
                    </div>
                  </LessonItem>
                ))}
            </LessonList>
          </PopRow>
          {moment(m[0].date).isAfter(moment(), 'day') ?
          <PopRow>
              <ItemButtons>
                <button onClick={() => showDeleteModal(m)}>{i18n.t("delete-reward")}</button>
                <button onClick={() => showEditModal(m)}>{i18n.t("edit")}</button>
              </ItemButtons>
          </PopRow> : null}
        </PopItem>
      });

      setSickList(ts);

    }
    else {
      setSickList([])
    }

    setLoading(false);
  }

  const getTime = (startdatetime, enddatetime) => {
    let start = moment(startdatetime)
    let end = moment(enddatetime)
    if (start.hour() === 0 && start.minute() === 0 && end.hour() === 0 && end.minute() === 0)
      return <span>{moment(startdatetime).format('DD MMM YYYY')} - {moment(enddatetime).format('DD MMM YYYY')}</span>
    else return <span>{moment(startdatetime).format('DD MMM YYYY')} - {moment(enddatetime).format('DD MMM YYYY')}</span>
  }


  const GetTypeIcon = (type: number) => {
    if (type === 1 || type === -1) {
      return <Attendance_Icon />
    } else if (type === 2) {
      return <Close_Icon />
    } else if (type === 3) {
      return <Clock_Icon />
    }
  }

  const getDateTime = (start, end) => {
    let starttime = start?.hours.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false
    }) + ":" + start?.minutes.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false
    })
    let endtime = end?.hours.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false
    }) + ":" + end?.minutes.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false
    })

    let datetimestring = starttime + " - " + endtime;
    return datetimestring;
  }


  const getTags = (tags, absence_id, absencetype) => {
    let t = []
    if (tags) {
      if (tags === null || tags.length < 0) return [];
      let ids = tags.split(',');
      for (let i = 0; i < ids.length; i++) {
        let tempTag = alltags?.find((t) => t.tag_id == ids[i]);
        if (tempTag) {
          t.push(<TagPill big={true} key={absence_id + "_tag_" + tempTag.tag_id} PColor={"#" + tempTag.html_color}>{i18n.t("tag-" + tempTag.name)}</TagPill>)
        }
        else if (ids[i] == "99") t.push(<TagPill big={true} key={absence_id + "_tag_" + absencetype} PColor={"#FED425"}>{i18n.t('tag-Late')}</TagPill>)
      }
    }
    return t
  }

  const handleDate = (date, type) => {
    if (type === 1) {
      setEditModal(prev => ({ ...prev, fromDate: date }))
    }
    else {
      setEditModal(prev => ({ ...prev, toDate: date }))
    }
  }

  const handleTextInput = (e) => {
    setEditModal(prev => ({ ...prev, text: e.target.value }))
  }

  const updateSickEvent = async () => {
    await db.deleteSickEvent4Student(editModal.absence_id)
    //await db.updateSickEvent(editModal.absence_id, editModal.fromDate, editModal.toDate, editModal.text)
    getSickTimeblocks()
    props.updateStudents()
    setEditModal(null)
  }


  return (
    <>
      {deleteModal !== null ? <Modal ref={deleteRef} onClose={closeDeleteModal} backColor='rgba(0,0,0,0.25)' clickOutside={true}>
        <PopContainer>
          <PopTitle>{toTitleCase(i18n.t("tooltip-registration-method-sick"))}</PopTitle>
          <HeadLine />
          <PopRow>{i18n.t("guardian-sickreport-delete-text")}</PopRow>
          <PopRow>
            <Buttons>
              <button onClick={() => deleteSickRequest()}>{i18n.t("delete-reward")}</button>
              <button onClick={() => closeDeleteModal()}>{i18n.t("cancel")}</button>
            </Buttons>
          </PopRow>
        </PopContainer>
      </Modal> : null}

      <Container>
        <TopTitle>
          <span>{toTitleCase(i18n.t("tooltip-registration-method-sick"))}</span>
        </TopTitle>
        <CardInfo padding={true} text={"info-text-sickleave"} />
        <BT onClick={() => setShowAll(!showAll)}>{showAll ? i18n.t("show-newest-sick") : i18n.t("show-all")}</BT>
        {!loading ?
          <ListContainer>
            {sickList.length > 0 ?
              sickList
              :
              <EmptyBox Graphic='user' text={i18n.t("guardian-sickleave-header-text1")} />
            }
          </ListContainer>
          :
          <RainbowLoader />
        }

      </Container>
    </>
  );
});

export default GuardianSick;
